package com.tregz.tremenz.io.model

/**
 * Where one catalogue source stands, so a tab can tell "still loading" and "could not load" apart
 * from "nothing there". [LOADED] means the source answered, even if it answered with an empty list.
 */
enum class ModelStatus {
    LOADING,
    LOADED,
    FAILED
}
